import React from 'react';
import useInView from '../hooks/useInView';

const About = () => {
  const [ref, inView] = useInView();

  return (
    <section id="about" className="py-20 md:py-32 px-6 md:px-12 max-w-6xl mx-auto border-t border-neutral-200 dark:border-white/10">
      <div
        ref={ref}
        className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
      >
        <div className="md:col-span-4">
          <h2 className="text-xs font-mono uppercase tracking-widest text-neutral-500 mb-4">
            01 / A propos de moi
          </h2>
          <div className="h-px bg-neutral-200 dark:bg-white/20 w-12 hidden md:block"></div>
        </div>
        <div className="md:col-span-8 space-y-4 md:space-y-6 text-base md:text-lg text-neutral-600 dark:text-neutral-300 leading-relaxed max-w-2xl">
          <p>
            Je suis étudiant en troisième année de développement web et logiciel, passionné par
            l’architecture, le code propre et l’expérience utilisateur. J’ai commencé par
            de simples scripts, et aujourd’hui je développe des applications full-stack
            capables de répondre à des problématiques concrètes.
          </p>
          <p>
            En dehors du code, je passe du temps à explorer les nouvelles technologies,
            à lire sur l’ingénierie logicielle et à approfondir ma compréhension du system design
            ainsi que des algorithmes fondamentaux.
          </p>
          <p>
            Mon objectif est d’intégrer une équipe d’ingénierie ambitieuse, où je pourrai
            contribuer à des projets à fort impact tout en continuant à progresser dans
            les pratiques et outils modernes du développement.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
